module.exports = __webpack_public_path__ + "assets/img/img207.1aac48a2.png";